import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { modifier } from 'ember-modifier';
import CheckboxControl from '../../../components/wr/form/controls/checkbox.gts';
export interface Signature {
    Element: HTMLFieldSetElement;
    Args: {
        legend?: string;
        activable?: boolean;
    };
    Blocks: {
        col1: [];
        col2?: [];
        legend?: [];
    };
}
const STYLES = {
    base: [
        'flex',
        'flex-col',
        'sm:grid',
        'sm:gap-6',
        'sm:grid-cols-3',
        'mb-6',
        'sm:mb-0',
        '[&:first-child>*]:sm:rounded-tr',
        '[&:last-child>*]:sm:rounded-br',
        '[&:last-child]:mb-2',
        /****** Cells ******/ '[&>*]:px-0',
        '[&>*]:sm:py-66',
        // first cell (legend)
        '[&>legend:first-child]:sm:bg-gradient-to-r',
        '[&>legend:first-child]:sm:from-white',
        '[&>legend:first-child]:sm:to-grey-light',
        '[&>legend:first-child]:text-purple',
        '[&>legend:first-child]:sm:text-right',
        '[&>legend:first-child]:sm:px-4',
        '[&>legend:first-child]:float-left',
        '[&>legend:first-child]:flex',
        '[&>legend:first-child]:items-center',
        '[&>legend:first-child]:sm:justify-start',
        '[&>legend:first-child]:md:lg:justify-end',
        '[&>legend:first-child]:gap-2',
        // Legend checkbox
        '[&>legend:first-child>input[type="checkbox"]]:border-purple',
        '[&>legend:first-child>input[type="checkbox"]]:ring-purple'
    ]
} as const;
export default class WrFormRowsFieldsetComponent extends Component<Signature> {
    @tracked
    needsColspan = false;
    @tracked
    isActive: boolean;
    constructor(owner1: unknown, args1: Signature['Args']){
        super(owner1, args1);
        if (args1.activable == true) {
            this.isActive = true;
        } else if (args1.activable == undefined) {
            this.isActive = true;
        } else {
            this.isActive = false;
        }
    }
    get styles() {
        const col2Styles1 = this.needsColspan ? [
            '[&>*:nth-child(2)]:col-span-2',
            '[&>*:nth-child(3)]:hidden'
        ] : [];
        return [
            ...STYLES.base,
            ...col2Styles1
        ].join(' ');
    }
    @action
    toggleActive() {
        this.isActive = !this.isActive;
    }
    get isDisabled() {
        return !this.isActive;
    }
    checkEmpty = modifier((element1)=>{
        if (element1.childElementCount == 0) this.needsColspan = true;
    });
    static{
        template(`
    <fieldset class={{this.styles}} disabled={{this.isDisabled}} ...attributes>
      <legend>
        {{#if (has-block 'legend')}}
          {{yield to='legend'}}
        {{else}}
          {{@legend}}
        {{/if}}

        {{#if @activable}}
          <CheckboxControl
            {{on 'click' this.toggleActive}}
            checked={{this.isActive}}
          />
        {{/if}}
      </legend>

      {{! second cell }}
      <div>{{yield to='col1'}}</div>

      <div {{this.checkEmpty}}>{{yield to='col2'}}</div>
    </fieldset>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3NlbWVpYS9wYWNrYWdlcy9lbWJlci1hZGRvbnMvdjIvZW1iZXItd2lzZXIvc3JjLy1wcml2YXRlL2NvbXBvbmVudHMvZm9ybS9maWVsZHNldC1yb3cuZ3RzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBDb21wb25lbnQgZnJvbSAnQGdsaW1tZXIvY29tcG9uZW50JztcbmltcG9ydCB7IG9uIH0gZnJvbSAnQGVtYmVyL21vZGlmaWVyJztcbmltcG9ydCB7IGFjdGlvbiB9IGZyb20gJ0BlbWJlci9vYmplY3QnO1xuaW1wb3J0IHsgdHJhY2tlZCB9IGZyb20gJ0BnbGltbWVyL3RyYWNraW5nJztcbmltcG9ydCB7IG1vZGlmaWVyIH0gZnJvbSAnZW1iZXItbW9kaWZpZXInO1xuaW1wb3J0IENoZWNrYm94Q29udHJvbCBmcm9tICcuLi8uLi8uLi9jb21wb25lbnRzL3dyL2Zvcm0vY29udHJvbHMvY2hlY2tib3guZ3RzJztcblxuZXhwb3J0IGludGVyZmFjZSBTaWduYXR1cmUge1xuICBFbGVtZW50OiBIVE1MRmllbGRTZXRFbGVtZW50O1xuICBBcmdzOiB7IGxlZ2VuZD86IHN0cmluZzsgYWN0aXZhYmxlPzogYm9vbGVhbiB9O1xuICBCbG9ja3M6IHtcbiAgICBjb2wxOiBbXTtcbiAgICBjb2wyPzogW107XG4gICAgbGVnZW5kPzogW107XG4gIH07XG59XG5cbmNvbnN0IFNUWUxFUyA9IHtcbiAgYmFzZTogW1xuICAgICdmbGV4JyxcbiAgICAnZmxleC1jb2wnLFxuICAgICdzbTpncmlkJyxcbiAgICAnc206Z2FwLTYnLFxuICAgICdzbTpncmlkLWNvbHMtMycsXG4gICAgJ21iLTYnLFxuICAgICdzbTptYi0wJyxcbiAgICAnWyY6Zmlyc3QtY2hpbGQ-Kl06c206cm91bmRlZC10cicsXG4gICAgJ1smOmxhc3QtY2hpbGQ-Kl06c206cm91bmRlZC1icicsXG4gICAgJ1smOmxhc3QtY2hpbGRdOm1iLTInLFxuXG4gICAgLyoqKioqKiBDZWxscyAqKioqKiovXG4gICAgJ1smPipdOnB4LTAnLFxuICAgICdbJj4qXTpzbTpweS02NicsXG5cbiAgICAvLyBmaXJzdCBjZWxsIChsZWdlbmQpXG4gICAgJ1smPmxlZ2VuZDpmaXJzdC1jaGlsZF06c206YmctZ3JhZGllbnQtdG8tcicsXG4gICAgJ1smPmxlZ2VuZDpmaXJzdC1jaGlsZF06c206ZnJvbS13aGl0ZScsXG4gICAgJ1smPmxlZ2VuZDpmaXJzdC1jaGlsZF06c206dG8tZ3JleS1saWdodCcsXG4gICAgJ1smPmxlZ2VuZDpmaXJzdC1jaGlsZF06dGV4dC1wdXJwbGUnLFxuICAgICdbJj5sZWdlbmQ6Zmlyc3QtY2hpbGRdOnNtOnRleHQtcmlnaHQnLFxuICAgICdbJj5sZWdlbmQ6Zmlyc3QtY2hpbGRdOnNtOnB4LTQnLFxuICAgICdbJj5sZWdlbmQ6Zmlyc3QtY2hpbGRdOmZsb2F0LWxlZnQnLFxuICAgICdbJj5sZWdlbmQ6Zmlyc3QtY2hpbGRdOmZsZXgnLFxuICAgICdbJj5sZWdlbmQ6Zmlyc3QtY2hpbGRdOml0ZW1zLWNlbnRlcicsXG4gICAgJ1smPmxlZ2VuZDpmaXJzdC1jaGlsZF06c206anVzdGlmeS1zdGFydCcsXG4gICAgJ1smPmxlZ2VuZDpmaXJzdC1jaGlsZF06bWQ6bGc6anVzdGlmeS1lbmQnLFxuICAgICdbJj5sZWdlbmQ6Zmlyc3QtY2hpbGRdOmdhcC0yJyxcblxuICAgIC8vIExlZ2VuZCBjaGVja2JveFxuICAgICdbJj5sZWdlbmQ6Zmlyc3QtY2hpbGQ-aW5wdXRbdHlwZT1cImNoZWNrYm94XCJdXTpib3JkZXItcHVycGxlJyxcbiAgICAnWyY-bGVnZW5kOmZpcnN0LWNoaWxkPmlucHV0W3R5cGU9XCJjaGVja2JveFwiXV06cmluZy1wdXJwbGUnXG4gIF1cbn0gYXMgY29uc3Q7XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFdyRm9ybVJvd3NGaWVsZHNldENvbXBvbmVudCBleHRlbmRzIENvbXBvbmVudDxTaWduYXR1cmU-IHtcbiAgQHRyYWNrZWQgbmVlZHNDb2xzcGFuID0gZmFsc2U7XG4gIEB0cmFja2VkIGlzQWN0aXZlOiBib29sZWFuO1xuXG4gIGNvbnN0cnVjdG9yKG93bmVyOiB1bmtub3duLCBhcmdzOiBTaWduYXR1cmVbJ0FyZ3MnXSkge1xuICAgIHN1cGVyKG93bmVyLCBhcmdzKTtcbiAgICBpZiAoYXJncy5hY3RpdmFibGUgPT0gdHJ1ZSkge1xuICAgICAgdGhpcy5pc0FjdGl2ZSA9IHRydWU7XG4gICAgfSBlbHNlIGlmIChhcmdzLmFjdGl2YWJsZSA9PSB1bmRlZmluZWQpIHtcbiAgICAgIHRoaXMuaXNBY3RpdmUgPSB0cnVlO1xuICAgIH0gZWxzZSB7XG4gICAgICB0aGlzLmlzQWN0aXZlID0gZmFsc2U7XG4gICAgfVxuICB9XG5cbiAgZ2V0IHN0eWxlcygpIHtcbiAgICBjb25zdCBjb2wyU3R5bGVzID0gdGhpcy5uZWVkc0NvbHNwYW5cbiAgICAgID8gWydbJj4qOm50aC1jaGlsZCgyKV06Y29sLXNwYW4tMicsICdbJj4qOm50aC1jaGlsZCgzKV06aGlkZGVuJ11cbiAgICAgIDogW107XG4gICAgcmV0dXJuIFsuLi5TVFlMRVMuYmFzZSwgLi4uY29sMlN0eWxlc10uam9pbignICcpO1xuICB9XG5cbiAgQGFjdGlvblxuICB0b2dnbGVBY3RpdmUoKSB7XG4gICAgdGhpcy5pc0FjdGl2ZSA9ICF0aGlzLmlzQWN0aXZlO1xuICB9XG5cbiAgZ2V0IGlzRGlzYWJsZWQoKSB7XG4gICAgcmV0dXJuICF0aGlzLmlzQWN0aXZlO1xuICB9XG5cbiAgY2hlY2tFbXB0eSA9IG1vZGlmaWVyKGVsZW1lbnQgPT4ge1xuICAgIGlmIChlbGVtZW50LmNoaWxkRWxlbWVudENvdW50ID09IDApIHRoaXMubmVlZHNDb2xzcGFuID0gdHJ1ZTtcbiAgfSk7XG5cbiAgPHRlbXBsYXRlPlxuICAgIDxmaWVsZHNldCBjbGFzcz17e3RoaXMuc3R5bGVzfX0gZGlzYWJsZWQ9e3t0aGlzLmlzRGlzYWJsZWR9fSAuLi5hdHRyaWJ1dGVzPlxuICAgICAgPGxlZ2VuZD5cbiAgICAgICAge3sjaWYgKGhhcy1ibG9jayAnbGVnZW5kJyl9fVxuICAgICAgICAgIHt7eWllbGQgdG89J2xlZ2VuZCd9fVxuICAgICAgICB7e2Vsc2V9fVxuICAgICAgICAgIHt7QGxlZ2VuZH19XG4gICAgICAgIHt7L2lmfX1cblxuICAgICAgICB7eyNpZiBAYWN0aXZhYmxlfX1cbiAgICAgICAgICA8Q2hlY2tib3hDb250cm9sXG4gICAgICAgICAgICB7e29uICdjbGljaycgdGhpcy50b2dnbGVBY3RpdmV9fVxuICAgICAgICAgICAgY2hlY2tlZD17e3RoaXMuaXNBY3RpdmV9fVxuICAgICAgICAgIC8-XG4gICAgICAgIHt7L2lmfX1cbiAgICAgIDwvbGVnZW5kPlxuXG4gICAgICB7eyEgc2Vjb25kIGNlbGwgfX1cbiAgICAgIDxkaXY-e3t5aWVsZCB0bz0nY29sMSd9fTwvZGl2PlxuXG4gICAgICA8ZGl2IHt7dGhpcy5jaGVja0VtcHR5fX0-e3t5aWVsZCB0bz0nY29sMid9fTwvZGl2PlxuICAgIDwvZmllbGRzZXQ-XG4gIDwvdGVtcGxhdGU-XG59XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sZUFBZSxxQkFBcUI7QUFDM0MsU0FBUyxFQUFFLFFBQVEsa0JBQWtCO0FBQ3JDLFNBQVMsTUFBTSxRQUFRLGdCQUFnQjtBQUN2QyxTQUFTLE9BQU8sUUFBUSxvQkFBb0I7QUFDNUMsU0FBUyxRQUFRLFFBQVEsaUJBQWlCO0FBQzFDLE9BQU8scUJBQXFCLG9EQUFvRDtBQUVoRixpQkFBaUI7SUFDZixTQUFTO0lBQ1Q7UUFBUSxTQUFTLE1BQU07UUFBRSxZQUFZLE9BQU87O0lBQzVDO1FBQ0U7UUFDQTtRQUNBOzs7QUFJSixNQUFNLFNBQVM7SUFDYixNQUFNO1FBQ0o7UUFDQTtRQUNBO1FBQ0E7UUFDQTtRQUNBO1FBQ0E7UUFDQTtRQUNBO1FBQ0E7UUFFQSxtQkFBbUIsR0FDbkI7UUFDQTtRQUVBLHNCQUFzQjtRQUN0QjtRQUNBO1FBQ0E7UUFDQTtRQUNBO1FBQ0E7UUFDQTtRQUNBO1FBQ0E7UUFDQTtRQUNBO1FBQ0E7UUFFQSxrQkFBa0I7UUFDbEI7UUFDQTtLQUNEO0FBQ0g7QUFFQSxlQUFlLE1BQU0sb0NBQW9DLFVBQVU7SUFDakUsQ0FBQztJQUFRLGVBQWUsTUFBTTtJQUM5QixDQUFDO0lBQVEsVUFBVSxPQUFPLENBQUM7SUFFM0IsWUFBWSxRQUFPLE9BQU8sRUFBRSxPQUFNLFVBQVUsT0FBTyxDQUFFO1FBQ25ELEtBQUssQ0FBQyxRQUFPO1FBQ2IsSUFBSSxNQUFLLFNBQVMsSUFBSSxNQUFNO1lBQzFCLElBQUksQ0FBQyxRQUFRLEdBQUc7UUFDbEIsT0FBTyxJQUFJLE1BQUssU0FBUyxJQUFJLFdBQVc7WUFDdEMsSUFBSSxDQUFDLFFBQVEsR0FBRztRQUNsQixPQUFPO1lBQ0wsSUFBSSxDQUFDLFFBQVEsR0FBRztRQUNsQjtJQUNGO0lBRUEsSUFBSSxTQUFTO1FBQ1gsTUFBTSxjQUFhLElBQUksQ0FBQyxZQUFZLEdBQ2hDO1lBQUM7WUFBaUM7U0FBNEIsR0FDOUQsRUFBRTtRQUNOLE9BQU87ZUFBSSxPQUFPLElBQUk7ZUFBSztTQUFXLENBQUMsSUFBSSxDQUFDO0lBQzlDO0lBRUEsQ0FBQztJQUNELGVBQWU7UUFDYixJQUFJLENBQUMsUUFBUSxHQUFHLENBQUMsSUFBSSxDQUFDLFFBQVE7SUFDaEM7SUFFQSxJQUFJLGFBQWE7UUFDZixPQUFPLENBQUMsSUFBSSxDQUFDLFFBQVE7SUFDdkI7SUFFQSxhQUFhLFNBQVMsQ0FBQTtRQUNwQixJQUFJLFNBQVEsaUJBQWlCLElBQUksR0FBRyxJQUFJLENBQUMsWUFBWSxHQUFHO0lBQzFELEdBQUc7SUFFSCxNQUFBO1FBQUEsU0FBVSxDQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0VBc0JWLENBQUEsRUFBQTtZQUFBLFdBQUEsSUFBVztZQUFYO2dCQUFBLE9BQUEsS0FBQSxTQUFBLENBQUEsRUFBVztZQUFEO1FBQUE7SUFBQSxDQXRCQTtBQXVCWiJ9